import { render, staticRenderFns } from "./WxpayPayConfig.vue?vue&type=template&id=1a3b8272&scoped=true"
import script from "./WxpayPayConfig.vue?vue&type=script&lang=js"
export * from "./WxpayPayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b8272",
  null
  
)

export default component.exports